import {
  GetFeedbackCommandInput,
  PutFeedbackCommandInput,
} from '@amzn/gbsa-helios-typescript-client';

export const feedbackKeys = {
  all: ['feedback'] as const,
  get: ({
    auditId,
    businessUnitId,
    createdBy,
    divisionId,
    questionId,
  }: Partial<Omit<GetFeedbackCommandInput, 'feedback'>>) =>
    [
      ...feedbackKeys.all,
      'get',
      auditId,
      businessUnitId,
      createdBy,
      divisionId,
      questionId,
    ] as const,
  put: ({
    auditId,
    businessUnitId,
    createdBy,
    divisionId,
    questionId,
  }: Pick<
    PutFeedbackCommandInput,
    'auditId' | 'businessUnitId' | 'createdBy' | 'divisionId' | 'questionId'
  >) =>
    [
      ...feedbackKeys.all,
      'put',
      auditId,
      businessUnitId,
      createdBy,
      divisionId,
      questionId,
    ] as const,
  export: ({ businessUnitId }: { businessUnitId?: string }) =>
    [...feedbackKeys.all, 'export', businessUnitId] as const,
};
